module.exports = "<!-- DENTRO DE APP-MENU ESTÁ EL ROUTER OUTLET -->\n<app-menu></app-menu>\n"